import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Input, Form } from "antd";

import ReactDOM from "react-dom";
import VerifySlide from "../../../../components/VerifySlide";
import AuthStore from "../../../../stores/AuthStore";
import { getParamFromUrlSearch } from "../../../../utils/paramsUtil";
import styles from "./index.module.scss";
import { isValidPhoneNumber } from "../../../../utils/regExp";

interface LoginByMobileProps {
  setLoginType: (state: number) => void;
}
const LoginByMobile: React.FC<LoginByMobileProps> = (props) => {
  const [form] = Form.useForm();
  const { setLoginType } = props;
  const [isSlideShow, setIsSlideShow] = useState(false);
  const [captchaVerification, setCaptchaVerification] = useState<string>();
  const [isCheck, setIsCheck] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [timeDown, setTimeDown] = useState("60");
  let timeTimer: any = null;
  const navigate = useNavigate();
  const { safeCode, isIntimePeriod } = AuthStore;
  const login = (captchaVerification?: string) => {
    // if (!captchaVerification) {
    //   setIsSlideShow(true);
    //   return;
    // }
    form
      .validateFields()
      .then((res) => {
        console.log(res);
        const values = form.getFieldsValue();
        const { phone, code } = values;
        const params = getParamFromUrlSearch<{ appkey?: string }>(
          document.location.search
        );
        AuthStore.ssoLoginMobile(phone, code, params.appkey).then((res) => {
          if (res) {
            !params.appkey && navigate("/client/userInfo/getUserInfo");
          } else {
            setCaptchaVerification(undefined);
          }
        });
      })
      .catch((err) => {});
  };
  const handleCheckPhone = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback();
    }
    isValidPhoneNumber(value) ? callback() : callback("手机号码格式错误");
  };
  const timer = () => {
    const phone = form.getFieldValue("phone");
    if (!isValidPhoneNumber(phone)) return;
    setIsSend(true);
    let number = 60;
    AuthStore.sendMsg(form.getFieldValue("phone"), safeCode);
    timeTimer = setInterval(() => {
      if (number === 0) {
        setTimeDown("重新发送");
        clearInterval(timeTimer);
      } else {
        number--;
        setTimeDown(String(number));
      }
    }, 1000);
  };
  return (
    <div className={styles.auth_form}>
      <div className={styles.title}>
        <div style={{ cursor: "pointer",color:'#FFC75D' }}>短信登录</div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => setLoginType(1)}
        >
          密码登录
        </div>
        <div style={{ cursor: "pointer" }} onClick={() => setLoginType(3)}> 钉钉扫码</div>
      </div>
      <div className={styles.line}>
        <div className={styles.lineChild}></div>
      </div>
      <Form form={form}>
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "请输入手机号",
            },
            {
              validator: handleCheckPhone,
            },
          ]}
        >
          <Input
            placeholder="请输入手机号码"
            className={styles.input}
            style={{ marginTop: "48px" }}
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item
          name="code"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "验证码不能为空",
            },
          ]}
        >
          <div className={styles.check}>
            <Input
              placeholder="请输入验证码"
              className={styles.input}
              style={{ width: "200px" }}
              autoComplete="off"
            />
            {isCheck && isIntimePeriod ? (
              <button
                type="button"
                onClick={() => {
                  (!isSend || timeDown === "重新发送") &&
                    isIntimePeriod &&
                    timer();
                }}
              >{`${isSend ? timeDown : "发送验证码"}`}</button>
            ) : (
              <button onClick={() => setIsSlideShow(true)}>安全校验</button>
            )}
          </div>
        </Form.Item>
      </Form>

      {ReactDOM.createPortal(
        <VerifySlide
          isSlideShow={isSlideShow}
          onCancel={() => setIsSlideShow(false)}
          onSuccess={(code: string = "") => {
            setIsCheck(true);
            AuthStore.setSafeCode(code);
            AuthStore.setIsIntimePeriod(true);
          }}
        />,
        document.body
      )}
      
      <button
        onClick={() => login(captchaVerification)}
        className={styles.login}
      >
        登录
      </button>
      {/* <div className={styles.registry} onClick={() => setIsLogin(false)}>
        <span>立即注册</span>
      </div> */}
    </div>
  );
};

export default LoginByMobile;
